import { render, staticRenderFns } from "./IGCommentManagement.vue?vue&type=template&id=2f58870d&scoped=true"
import script from "./IGCommentManagement.vue?vue&type=script&lang=js"
export * from "./IGCommentManagement.vue?vue&type=script&lang=js"
import style0 from "./IGCommentManagement.vue?vue&type=style&index=0&id=2f58870d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f58870d",
  null
  
)

export default component.exports